<template>
    <default-layout>

        <div class="row">
            <div class="col-12">
                <div class="btn-toolbar float-right" role="toolbar" aria-label="Distributors toolbar">
                    <div class="btn-group mr-2" role="group" aria-label="Distributors toolbar, first group">
                        <button type="button" class="btn-sm page-link mr-2" @click="onRefresh">
                            <font-awesome-icon class="mr-1" icon="sync"/>
                            Refresh
                        </button>
                        <button type="button" class="btn-sm page-link" @click="exportCsv" title="Export CSV">
                            <font-awesome-icon class="mr-1" icon="file-csv"/>
                            Export CSV
                        </button>
                    </div>
                </div>
                <h1 class="h4 mb-4 clearfix">
                    Distributors
                    <span class="badge badge-pill badge-primary" v-if="distributors.total">{{ distributors.total }}</span>
                </h1>
            </div>
        </div>

        <div class="row" v-if="loading === true">
            <div class="col-12">
                <spinner-component class="p-5" type="spinner-grow"/>
            </div>
        </div>

        <div class="row" v-if="loading === false">
            <div class="col-12">
                <form class="form-inline mb-4" @submit.prevent="onRefresh">
                    <div class="form-group mr-2">
                        <input class="form-control form-control-sm" type="text" placeholder="Search..." v-model="filter[0].value">
                    </div>
                    <button type="submit" class="btn btn-sm btn-primary">Search</button>
                </form>
            </div>

            <div class="col-12 clearfix">
                <pagination-component :page="page" :limit="limit" :total="distributors.total" @paginate="onChangePage"/>

                <div class="btn-toolbar float-right" role="toolbar" aria-label="Distributor table per page">
                    <div class="btn-group mr-2" role="group" aria-label="Distributors toolbar, first group">
                        <form class="form-inline mb-4" @change="onRefresh">
                            <div class="form-group">
                                <label class="mr-2" for="distributor-per-page">
                                    <small>Distributors per page</small>
                                </label>
                                <select id="distributor-per-page" class="form-control form-control-sm" v-model="limit">
                                    <option value="10">10</option>
                                    <option value="25">25</option>
                                    <option value="50">50</option>
                                    <option value="75">75</option>
                                    <option value="100">100</option>
                                    <option value="500">500</option>
                                </select>
                            </div>
                        </form>
                    </div>
                </div>
            </div>

            <div class="col-12">
                <div class="table-responsive">
                    <table id="distributors" class="table">
                        <thead>
                        <tr>
                            <th>Name</th>
                            <th>Type</th>
                            <th>Email</th>
                            <th>Billing address</th>
                            <th>Actions</th>
                        </tr>
                        </thead>
                        <tbody>

                        <tr v-for="(distributor, index) in distributors.list" :key="index">
                            <td class="align-middle">
                                <v-gravatar class="mr-2 rounded-circle" :size="20" :email="distributor.email"/>
                                {{ distributor.firstName }} {{ distributor.lastName }}
                            </td>
                            <td class="align-middle">
                                <span class="badge badge-dark">Distributor</span>
                            </td>
                            <td class="align-middle">
                                <a :href="'mailto:' + distributor.email">{{ distributor.email }}</a>
                            </td>
                            <td>
                                <address class="small mb-0">
                                    {{ distributor.billingAddress.street }}
                                    <br>
                                    {{ distributor.billingAddress.postcode }}, {{ distributor.billingAddress.city }}
                                    {{ distributor.billingAddress.country }} {{ distributor.billingAddress.state }}
                                </address>
                            </td>
                            <td>
                                <router-link class="btn btn-sm btn-outline-dark"
                                             title="Distributor licenses"
                                             :to="'/distributors/' + distributor.id">
                                    <font-awesome-icon icon="truck"/>
                                </router-link>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <div class="col-12 clearfix">
                <pagination-component :page="page" :limit="limit" :total="distributors.total" @paginate="onChangePage"/>
            </div>
        </div>

    </default-layout>
</template>

<script>
    import DefaultLayout from "@/components/layout/DefaultLayout";
    import SpinnerComponent from "@/components/ui/SpinnerComponent";
    import PaginationComponent from "@/components/PaginationComponent";
    import serviceEnv from "@/services/env.js";
    import moment from "moment";

    export default {
        name: "DistributorsPage",
        components: {PaginationComponent, SpinnerComponent, DefaultLayout },
        computed: {
        },
        data() {
            return {
                page: 1,
                limit: 10,
                filter: [
                    {
                        key: 'email',
                        value: ''
                    }
                ],
                loading: true,
                distributors: {
                    total: 0,
                    list: []
                }
            }
        },
        methods: {
            async onRefresh() {
                this.loading = true;
                let customerId = '47af5b78-7bdd-40f2-bea0-ce4b5c4afde5';

                if (serviceEnv.config.environment === 'PROD') {
                    customerId = '79cd45cd-6ccb-4d11-8e28-f6dda73a34fe';
                }

                await this.$store.dispatch('cliffMarket/getCustomer', customerId)
                    .then(customer => {
                        this.distributors = {
                            total: 1,
                            list: [customer]
                        }
                    });

                this.loading = false;
            },
            onChangePage(page) {
                if (page <= 0) {
                    return;
                }

                this.page = parseInt(page);
                this.onRefresh();
            },
            exportCsv() {
                let exportData = [];
                let csvContent = "data:text/csv;charset=utf-8,";

                this.distributors.list.forEach(distributor => {
                    exportData.push({
                        CUSTOMER_ID: distributor.id,
                        CUSTOMER_EMAIL: distributor.email,
                        CUSTOMER_SALUTATION: distributor.salutation,
                        CUSTOMER_FIRST_NAME:  distributor.firstName,
                        CUSTOMER_LAST_NAME:  distributor.lastName,
                        CUSTOMER_BIRTHDAY: distributor.birthday,
                        CUSTOMER_STREET: distributor.street,
                        CUSTOMER_COMPANY: distributor.company,
                        CUSTOMER_POSTCODE: distributor.postcode,
                        CUSTOMER_CITY: distributor.city,
                        CUSTOMER_COUNTRY: distributor.country,
                        CUSTOMER_STATE: distributor.state,
                        CUSTOMER_BILLING_ADDRESS_SALUTATION: distributor.billingAddress.salutation,
                        CUSTOMER_BILLING_ADDRESS_FIRST_NAME:  distributor.billingAddress.firstName,
                        CUSTOMER_BILLING_ADDRESS_LAST_NAME:  distributor.billingAddress.lastName,
                        CUSTOMER_BILLING_ADDRESS_BIRTHDAY: distributor.billingAddress.birthday,
                        CUSTOMER_BILLING_ADDRESS_STREET: distributor.billingAddress.street,
                        CUSTOMER_BILLING_ADDRESS_COMPANY: distributor.billingAddress.company,
                        CUSTOMER_BILLING_ADDRESS_VAT_ID: distributor.billingAddress.vatId,
                        CUSTOMER_BILLING_ADDRESS_POSTCODE: distributor.billingAddress.postcode,
                        CUSTOMER_BILLING_ADDRESS_CITY: distributor.billingAddress.city,
                        CUSTOMER_BILLING_ADDRESS_COUNTRY: distributor.billingAddress.country,
                        CUSTOMER_BILLING_ADDRESS_STATE: distributor.billingAddress.state,
                        CUSTOMER_SHIPPING_ADDRESS_SALUTATION: distributor.shippingAddress.salutation,
                        CUSTOMER_SHIPPING_ADDRESS_FIRST_NAME:  distributor.shippingAddress.firstName,
                        CUSTOMER_SHIPPING_ADDRESS_LAST_NAME:  distributor.shippingAddress.lastName,
                        CUSTOMER_SHIPPING_ADDRESS_BIRTHDAY: distributor.shippingAddress.birthday,
                        CUSTOMER_SHIPPING_ADDRESS_STREET: distributor.shippingAddress.street,
                        CUSTOMER_SHIPPING_ADDRESS_COMPANY: distributor.shippingAddress.company,
                        CUSTOMER_SHIPPING_ADDRESS_VAT_ID: distributor.shippingAddress.vatId,
                        CUSTOMER_SHIPPING_ADDRESS_POSTCODE: distributor.shippingAddress.postcode,
                        CUSTOMER_SHIPPING_ADDRESS_CITY: distributor.shippingAddress.city,
                        CUSTOMER_SHIPPING_ADDRESS_COUNTRY: distributor.shippingAddress.country,
                        CUSTOMER_SHIPPING_ADDRESS_STATE: distributor.shippingAddress.state
                    });
                });

                csvContent += [
                    Object.keys(exportData[0]).join(";"),
                    ...exportData.map(customer => Object.values(customer).join(";"))
                ]
                    .join("\n")
                    .replace(/(^\[)|(\]$)/gm, "");

                const data = encodeURI(csvContent);
                const link = document.createElement("a");
                link.setAttribute("href", data);
                link.setAttribute("download", "interactive-link-export-customers-" + moment().format('YYYYMMDD-HHMMSS') + ".csv");
                link.click();
            }
        },
        async beforeMount() {
            this.onRefresh();
        }
    }
</script>

<style lang="scss" scoped>

</style>